module.exports = __webpack_public_path__ + "img/heart.db160040.png";